export const isLatestTiptapVersionSelected = ({
  latestTiptapVersion,
  selectedTiptapVersion,
}: {
  latestTiptapVersion: number | null;
  selectedTiptapVersion: number | null;
}) => {
  const effectiveSelectedVersion = selectedTiptapVersion ?? latestTiptapVersion;

  return (
    effectiveSelectedVersion !== null &&
    latestTiptapVersion !== null &&
    effectiveSelectedVersion === latestTiptapVersion
  );
};

export const getTiptapLifecycleActionState = ({
  canCreateBackendRevision,
  hasReadyEditor,
  isBackendVersionLocked,
  isVersionHistorySynced,
  latestTiptapVersion,
  selectedTiptapVersion,
}: {
  canCreateBackendRevision: boolean;
  hasReadyEditor: boolean;
  isBackendVersionLocked: boolean;
  isVersionHistorySynced: boolean;
  latestTiptapVersion: number | null;
  selectedTiptapVersion: number | null;
}) => {
  const canUseLifecycleActions =
    isVersionHistorySynced &&
    isLatestTiptapVersionSelected({
      latestTiptapVersion,
      selectedTiptapVersion,
    });

  return {
    canCreateNewRevision:
      canUseLifecycleActions && canCreateBackendRevision && hasReadyEditor,
    canResumeEditing:
      canUseLifecycleActions &&
      isBackendVersionLocked &&
      !canCreateBackendRevision,
  };
};
